"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParentDimensions = exports.withParentDimensions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const withParentDimensions = (Component) => {
    const ReturnComponent = (props) => {
        const [targetRef, parentDimensions] = (0, exports.useParentDimensions)();
        return ((0, jsx_runtime_1.jsx)("div", { ref: targetRef, style: { width: "100%", boxSizing: "border-box" }, children: parentDimensions && ((0, jsx_runtime_1.jsx)(Component, { ...props, parentDimensions: parentDimensions })) }));
    };
    return ReturnComponent;
};
exports.withParentDimensions = withParentDimensions;
const useParentDimensions = () => {
    const targetRef = (0, react_1.useRef)(null);
    const [width, setWidth] = (0, react_1.useState)(0);
    const [height, setHeight] = (0, react_1.useState)(0);
    const solveDimensions = () => {
        if (targetRef.current && targetRef.current.parentElement) {
            const { width: widthFromStyle, height: heightFromStyle, paddingLeft, paddingRight, paddingTop, paddingBottom, } = getComputedStyle(targetRef.current.parentElement);
            const p = (s) => (s ? parseFloat(s) : 0);
            const elementWidth = p(widthFromStyle) - p(paddingLeft) - p(paddingRight);
            const elementHeight = p(heightFromStyle) - p(paddingTop) - p(paddingBottom);
            if (width !== elementWidth) {
                setWidth(elementWidth);
            }
            if (height !== elementHeight) {
                setHeight(elementHeight);
            }
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        solveDimensions();
        window.addEventListener("resize", solveDimensions, false);
        return () => {
            window.removeEventListener("resize", solveDimensions);
        };
    });
    return [targetRef, { width, height }];
};
exports.useParentDimensions = useParentDimensions;
